module.exports = __webpack_public_path__ + "static/icons/icon-sandbar-6d7ed152854d938b46ab96f9138f84b8.svg";